import difference from 'lodash/difference';
import { computed, makeObservable } from 'mobx';

import { AbstractField } from './AbstractField';

export class TextListField extends AbstractField<string[], string[]> {
    constructor(params: string[], name: string) {
        super(params, name);
        makeObservable(this);
    }

    @computed
    public get hasDate(): boolean {
        return this.fieldValue.length > 0;
    }

    public isEqual(value: string[]): boolean {
        return difference(value, this.fieldValue).length === 0;
    }

    public getPreview(): string {
        return this.fieldValue.join(', ');
    }

    public makeUpdateParams(): string[] {
        return this.fieldValue;
    }

    protected setDefaultValueValue(): void {
        this.defaultNullValue = [];
    }

    protected setFieldValue(value: string[]): void {
        this.fieldValue = value;
    }
}
